// extracted by mini-css-extract-plugin
module.exports = {"b1uioams":"b1uioams","active":"active"};